import React from 'react' 
import { Dashboard, Login, PrivateRoute, AuthWrapper, Error } from './pages';  
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './Main.css';

import './Main.css';

const Main = () => {
  return (
    <AuthWrapper>
      <Router> 
      <Routes>
        <Route path='/' element= { 
          <PrivateRoute>
            <Dashboard/>
          </PrivateRoute>
         } />
        <Route path='login' element= {<Login/>} /> 
        <Route path='*' element={<Error />} />
      </Routes>
    </Router>
    </AuthWrapper>
    
  )
}

export default Main